<template>
  <div class="experience-description">
    <div
      v-for="(experience, index) in translatedExperiences"
      :key="index"
      class="description-card"
    >
      <span class="date">{{ experience.date }}</span>
      <h4 class="title">
        {{ experience.company }} <span class="role">| {{ experience.position }}</span>
      </h4>
      <p class="description">{{ experience.description }}</p>
      <div class="technologies">
        <span v-for="(tech, i) in experience.technologies" :key="i" class="badge">
          {{ tech }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "vue";
import i18n from "@/i18n/i18n";

export default {
  setup() {
    const experiences = computed(() => i18n.get("experiences"));
    const translatedExperiences = computed(() =>
      experiences.value.map((experience) => ({
        ...experience,
        position: i18n.get(experience.position),
        date: i18n.get(experience.date),
        description: i18n.get(experience.description),
      }))
    );

    return {
      translatedExperiences,
    };
  },
};
</script>

<style scoped>
.experience-description {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: "Helvetica Nos Micro Regular", sans-serif;
}

.description-card {
  border: 0.1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px 24px;
  transition: all 0.5s ease-in-out;
  background-color: #fff;
}

.date {
  font-size: 0.875rem;
  color: #4b5563;
  margin-bottom: 8px;
}

.title {
  font-size: 1rem;
  font-weight: bold;
  color: #111827;
}

.role {
  font-weight: lighter;
  color: #6b7280;
}

.description {
  font-size: 0.875rem;
  color: #4b5563;
}

.badge {
  background-color: #e0f2f1;
  color: #00796b;
  font-size: 0.75rem;
  padding: 4px 8px;
  border-radius: 8px;
  margin-right: 8px;
}

/* Responsividade */
@media (max-width: 768px) {
  .experience-description {
    padding: 16px;
  }

  .description-card {
    padding: 12px 16px;
  }

  .title {
    font-size: 0.9rem;
  }

  .badge {
    font-size: 0.65rem;
  }
}
</style>
